import React, { useState, useEffect } from 'react';
import './BackToTopButton.css';
// import { FaAnglesUp } from "react-icons/fa6";
import { AiOutlineArrowUp } from "react-icons/ai";
// import { FaAnglesUp } from "react-icons/fa";


const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show the button when the user scrolls down
  useEffect(() => {
    const scrollHandler = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', scrollHandler);

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  // Scroll to the top of the page when the button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className={`back-to-top-button ${isVisible ? 'visible' : ''}`} onClick={scrollToTop}>
      {/* <button > */}
        <AiOutlineArrowUp  />
      {/* </button> */}
    </div>
  );
};

export default BackToTopButton;
